import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbButton, AbButtonType } from "abreact/misc/AbButton";
import { AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import * as AbHooks from "abreact/utils/AbHooks";
import { AbIcon } from "absdk/commons/ui/misc/AbIcon";
import * as React from "react";
export function AbInlineNotification(props) {
  const {
    message,
    icon,
    buttons,
    size,
    onClose,
    details,
    onDetails,
    onViewDetails
  } = {
    ...props
  };
  const severity = props.severity ?? "information";
  const isMounted = AbHooks.useIsMounted();
  const [showInlineDetails, setShowInlineDetails] = React.useState(false);
  const [isHidingViewDetailsButton, setIsHidingViewDetailsButton] = React.useState(false);
  const contextSize = React.useContext(AbSizeContext);
  const classes = [getSeverityClassName(severity), onClose && "ab-closeable-notification", buttons && "ab-inline-notification-with-buttons", size ?? contextSize];
  React.useEffect(() => {
    if (details) setIsHidingViewDetailsButton(false);
    if (onDetails || onViewDetails) setShowInlineDetails(false);
  }, [details, onDetails, onViewDetails]);
  const inner = /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-inline-notification", props, classes), {
    role: "alert",
    "aria-live": "polite",
    "aria-atomic": "true"
  }), (severity !== "custom" || icon) && /*#__PURE__*/React.createElement(AbIcon, {
    className: "ab-notification-icon",
    image: icon ?? getSeverityIconName(severity)
  }), /*#__PURE__*/React.createElement("div", {
    className: "ab-notification-message-area"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ab-notification-message"
  }, message), showInlineDetails && /*#__PURE__*/React.createElement("div", {
    className: "ab-notification-details"
  }, details)), (details || onDetails || onViewDetails) && /*#__PURE__*/React.createElement(AbButton, _extends({}, ReactUtils.componentProps("ab-notification-details-button", {}, [isHidingViewDetailsButton && "ab-notification-details-button-hidden"]), {
    dataTestId: "ab-inline-notification.details-button",
    type: AbButtonType.LINK,
    label: showInlineDetails ? AbReactResources.notification_hideDetails() : AbReactResources.notification_viewDetails(),
    onClick: () => {
      if (details) setShowInlineDetails(v => !v);else if (onDetails) onDetails();else if (onViewDetails) {
        setIsHidingViewDetailsButton(true);
        onViewDetails(() => {
          // Avoid error: "Can't perform a React state update on an unmounted component"
          if (!isMounted.current) return;
          setIsHidingViewDetailsButton(false);
        });
      }
    }
  })), buttons && buttons.map((buttonProps, index) => {
    return /*#__PURE__*/React.createElement(AbButton, _extends({
      key: index,
      className: "ab-notification-button ab-no-border-button"
    }, buttonProps));
  }), onClose && /*#__PURE__*/React.createElement(AbButton, {
    className: "ab-notification-close-button ab-notification-button ab-no-border-button",
    dataTestId: "ab-inline-notification.close-button",
    icon: "absdk:close",
    onClick: onClose
  }));
  return sizeProviderWrapper(inner, props, contextSize);
}
function getSeverityClassName(severity) {
  switch (severity) {
    case "custom":
      return undefined;
    case "success":
      return "ab-success-notification";
    case "warning":
      return "ab-warning-notification";
    case "error":
      return "ab-error-notification";
    default:
      return "ab-information-notification";
  }
}
function getSeverityIconName(severity) {
  switch (severity) {
    case "success":
      return "absdk:success";
    case "error":
      return "absdk:error";
    case "warning":
      return "absdk:warning";
    default:
      return "absdk:info-fill";
  }
}
//# sourceMappingURL=AbInlineNotification.js.map
